import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import type { SelectProps as MuiSelectProps } from "@mui/material";
import { TkSelectFormProps } from "../../../type/componentsType/TkSelectForm";
import React, { forwardRef, useEffect } from "react";
import "./_style.scss";

/**
 * プルダウン部品
 * selectPropsで渡した配列の要素を項目とするプルダウンを表示する
 * @param {string} errorMessage {errors.スキーマで定義した名前?.message}で設定
 * @param {[{value: string, label: string}]} selectPropsList 選択項目
 * @param {string} selectedValue 初期表示で選択させる要素の番号を文字列で設定
 * @param {string} minW 最小幅
 * @param {any} wantToSetValue デフォルト値
 * @return TkSelectForm プルダウン部品
 */
export const TkSelectForm: React.FC<TkSelectFormProps & MuiSelectProps> =
  forwardRef(
    (
      {
        errorMessage,
        selectPropsList,
        minW = "150px",
        fullWidth,
        label,
        onChange,
        onGetValue,
        disabled,
        placeholder,
        required,
        wantToSetValue,
        variant = "standard",
        className,
        isGuideMessage = false,
        guideMessage,
        ...rest
      },
      ref
    ) => {
      const [state, setState] = React.useState(wantToSetValue || "");

      useEffect(() => {
        setState(wantToSetValue || "");

        if (wantToSetValue !== null && wantToSetValue !== undefined) {
          const defaultValue = {
            target: {
              value: wantToSetValue,
            },
          } as React.ChangeEvent<HTMLInputElement>;
          onChange && onChange(defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [wantToSetValue]);

      const handelOnChange = (event: any) => {
        setState(event.target.value);
        onGetValue && onGetValue(event.target.value);
        onChange && onChange(event);
      };

      return (
        <FormControl
          variant={variant}
          className={`${className}`}
          sx={{ minWidth: minW }}
          fullWidth={fullWidth}
          required={required}
          data-testid="tkSeletFormCForTest"
        >
          <InputLabel id="select-label">{label}</InputLabel>
          <Select
            ref={ref}
            data-testid="tkSelectFromForTest"
            labelId="select-label"
            {...rest}
            label={label}
            value={state}
            onChange={handelOnChange}
            disabled={disabled}
            displayEmpty
            inputProps={{ "data-testid": "tkSelectFromForTestInput" }}
            renderValue={
              state !== "" ? undefined : () => <em>{placeholder}</em>
            }
          >
            <MenuItem className="noValueItem" value="" key={""}></MenuItem>
            {selectPropsList?.map((props, index) => (
              <MenuItem
                className="TkSelectiValueItem"
                data-testid="tkSelectItemFromForTest"
                key={`${props.value}${index}`}
                value={props.value}
              >
                {props.label}
              </MenuItem>
            ))}
          </Select>
          {!!errorMessage && (
            <FormHelperText error>{errorMessage}</FormHelperText>
          )}
          {isGuideMessage && (
            <Box className="selectFormGuide">{guideMessage}</Box>
          )}
        </FormControl>
      );
    }
  );

export default TkSelectForm;
